// extracted by mini-css-extract-plugin
export default {"prev":"PrevArrow-module--prev--a1395","black":"PrevArrow-module--black--2842e"};